import styled from "styled-components";

export const AdyenDigitalGiftCardCCInputsGridAreaName = "adyenForm";

export const AdyenDigitalGiftCardCCInputsWrapper = styled.div(() => ({
  gridArea: AdyenDigitalGiftCardCCInputsGridAreaName,
}));
